import { Button, Col, Row } from "reactstrap";

import CommonModal from "@components/ui-components/modal";
import DataTableView from "@components/views/datatable-view";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertSurvey from "./upsert";
import usePageChange from "@hooks/use-page-change";
import useSurveys from "./use-surveys";
import { useTranslation } from "react-i18next";

const Surveys = () => {

    const {
        data: { surveys = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        modalConfig,
        handleModalConfig,
        getAllSurveys,
        handleSurveyType,
        isOpen,
        handleAddSurvey
    } = useSurveys();

    const { t } = useTranslation();
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Surveys"
                breadcrumbItems={{
                    items: [
                        {
                            title : "Surveys",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: surveys,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleAddSurvey()}
                        subject="surveys"
                        text="Add Survey"/>
                }/>

            <CommonModal
                isOpen={isOpen}
                type="large"
                handleModal={() => handleAddSurvey()}
                title="New Survey"
                body={
                    <>
                        <Flex justify="center" align="center" className="my-1">
                            <h2>{t("Select Survey Type:")}</h2>
                        </Flex>
                        <Row className="mb-1 survey-type-modal">
                            <Col md={6} onClick={() => handleSurveyType("nps")}>
                                <Flex
                                    className="border p-2 rounded text-center type-card"
                                    justify="center"
                                    align="center"
                                    column>
                                    <div className="bg-light-success w-max p-50 rounded mb-2">
                                        <i className="mdi mdi-star font-medium-4"></i>
                                    </div>
                                    <h3>{t("Net Promoter Score (NPS)")}</h3>
                                    <p>
                                        {t(
                                            "Calculate your Promoter Score by asking customers how likely they are to recommend your brand"
                                        )}
                                    </p>
                                    <Button
                                        color="primary"
                                        className="mt-2"
                                        onClick={() => handleSurveyType("nps")}>
                                        {t("NPS Survey")}
                                    </Button>
                                </Flex>
                            </Col>

                            <Col
                                md={6}
                                onClick={() => handleSurveyType("csat")}>
                                <Flex
                                    className="border p-2 text-center type-card"
                                    justify="center"
                                    align="center"
                                    column>
                                    <div className="bg-light-info w-max p-50 rounded mb-2">
                                        <i className="mdi mdi-emoticon-happy-outline font-medium-4"></i>
                                    </div>
                                    <h3>{t("Customer Satisfaction (CSAT)")}</h3>
                                    <p>
                                        {t(
                                            "Calculate your CSAT score by asking customers how satisfied they are with your product"
                                        )}
                                    </p>
                                    <Button
                                        color="primary"
                                        className="mt-2"
                                        onClick={() => handleSurveyType("csat")
                                        }>
                                        {t("CSAT Survey")}
                                    </Button>
                                </Flex>
                            </Col>
                        </Row>
                    </>
                }/>
            <UpsertSurvey
                modalConfig={modalConfig}
                handleModal={handleModalConfig}
                getAllSurveys={getAllSurveys}/>
        </>
    );
};

export default Surveys;
